// extracted by mini-css-extract-plugin
var _1 = "dPd2g";
var _2 = "rApVA";
export { _1 as "base", _2 as "editor" }
